import React from "react";
import {
  isEmpty
} from "../../../constants/constant";
import { Box } from "../../ui";

const SnpCustomProgress = ({ center = true, size = 60, text = "" }) => {
  return (
    <Box
      style={{
        display: center ? "flex" : "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        height: center ? "100vh" : "auto",
        width: center ? "100vw" : "auto",
        position: "fixed",
        top: 0,
        left: 0,
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        zIndex: 9999, // Ensure it's above all UI elements
        pointerEvents: "none", // Block interactions
      }}
    >
      <div
        style={{
          position: "relative",
          width: size,
          height: size,
        }}
      >
        {/* Spinning circle */}
        <div
          style={{
            width: size,
            height: size,
            border: `${size / 10}px solid #ccc`,
            borderTop: `${size / 10}px solid #1976d2`,
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            boxSizing: "border-box",
          }}
        />

        {/* Inner Text */}
              {
                  !isEmpty(text) &&
                  <div
                      style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          fontSize: size / 5,
                          color: "#1976d2",
                          fontWeight: "bold",
                          userSelect: "none",
                      }}
                  >
                      {text}
                  </div>
              }
      </div>

      {/* Keyframes */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </Box>
  );
};

export default SnpCustomProgress;
